import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=02fca41e"
import script from "./Favourites.vue?vue&type=script&lang=ts"
export * from "./Favourites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports